import { enc } from 'crypto-js';

export const SECRET_KEY = enc.Utf8.parse('69643446f251923a');
export const SECRET_IV = enc.Utf8.parse('1b8f27804a37cf46');